import { Component, HostListener, ViewChild } from "@angular/core";
import { Content, NavParams, ViewController } from "ionic-angular";
import { IonNumericKeyboardOptions } from "../ion-numeric-keyboard/ion-numeric-keyboard";

export interface LoginModalData {
    translation?: { title: string, subtitle: string },
    baseLimit?: number,
    hasLimitVariant: boolean;
    isOutputHidden?: boolean,
    isPreviewAsterisked?: boolean
}

@Component({
    selector: "login-modal",
    templateUrl: "login-modal.html"
})

export class LoginModalComponent {
    private isPreviewAsterisked: boolean = !!this.navParams.get("isPreviewAsterisked");

    public baseLimit: number = this.navParams.get("baseLimit");

    public isOutputHidden: boolean = !!this.navParams.get("isOutputHidden");

    public translation: any = this.navParams.get("translation");

    public input: string = "";

    public isTimeOfBirthFormat: boolean | null = null;

    public keyboardOptions: IonNumericKeyboardOptions = {
        contentComponent: null,
        rightControlKey: {
            type: "icon",
            value: "backspace"
        },
        leftControlKey: {
            type: "text",
            value: "C"
        }
    };

    private isDismissing: boolean = false;

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if(event.key.toString() === "Escape") {
            this.dismissCancelRole();

            return false;
        }

        if (event.key.toString() === "Backspace") {
            this.onClick({ source: "RIGHT_CONTROL", key: null });
        }
        else if (!isNaN(Number(event.key))) {
            this.onClick({ source: "NUMERIC_KEY", key: event.key });
        }

        return false;
    }

    @HostListener('window:click', ['$event'])
    handleClickEvent(event: KeyboardEvent) {
        if((event.target as HTMLElement).tagName === "ION-BACKDROP") {
            this.dismissCancelRole();
        }

        return false;
    }

    @ViewChild("content") content: Content;

    constructor(private viewCtrl: ViewController, private navParams: NavParams) {
        this.keyboardOptions.contentComponent = this.content;

        if(this.navParams.get("hasLimitVariant")) {
            /* Enable */
            this.isTimeOfBirthFormat = false;
        }
    }

    public dismissCancelRole(event?: Event) {
        if(!this.isDismissing) {
            this.isDismissing = true;

            this.viewCtrl.dismiss(undefined, "cancel");
        }
    }

    private getLimit() {
        if(this.isTimeOfBirthFormat === null) {
            return this.baseLimit;
        }

        return this.isTimeOfBirthFormat ? this.baseLimit - 1 : this.baseLimit;
    }

    public onClick(event) {
        var limit = this.getLimit();

        if (event.source === "LEFT_CONTROL") {
            this.input = "";
        }
        else if (event.source === "RIGHT_CONTROL") {
            this.input = this.input.substring(0, this.input.length - 1);
        }
        else if (event.source === "NUMERIC_KEY") {
            if (this.input.length < limit) {
                if (this.input.length === 6) {
                    this.input += '-';
                }

                this.input += event.key;

                if (this.input.length === limit) {
                    this.submit();
                }
            }
        }
    }

    public previewInput() {
        let text = 0 < this.input.length ? "" : this.getLimit() === 11 ? "YYMMDD-XXXX" : "YYMMDD-XXX";

        if (this.isPreviewAsterisked) {
            for (let i = 0; i < this.input.length; i++) {
                text += i !== (this.input.length - 1) ? "*" : this.input[i];
            }
        }
        else {
            text = this.input;
        }

        return text;
    }

    public submit() {
        if (!this.isDismissing) {
            this.isDismissing = true;

            this.viewCtrl.dismiss({ value: this.input });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/login-modal/login-modal.ts